import searchLineStyle from 'src/components/View/Header/searchLine.style';

const selectStatusStyle = (theme) => ({
  root: {
    ...searchLineStyle(theme)?.innerField,
    cursor: 'pointer',

    // ellipsize the selected value
    '& .input': {
      ...searchLineStyle(theme)?.innerField['& .input'],
      cursor: 'pointer',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },

  innerFieldDropDown: {
    ...searchLineStyle(theme)?.innerFieldDropDown,
    padding: 0,
    width: '100%',
    marginLeft: 0,

    // cap to ~8 rows of ~40px (8 × 40 = 320px)
    maxHeight: '320px',
    overflowY: 'auto',

    '& .selectButton': {
      position: 'relative',
      display: 'block',
      width: '100%',
      // bump vertical padding for more breathing room
      padding: '8px 16px',
      fontSize: '14px',
      lineHeight: '18px',
      margin: 0,
      textAlign: 'left',
      cursor: 'pointer',
      background: 'none !important',
      border: 'none !important',

      // ellipsize long option text
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',

      '&.checked': {
        background: 'rgba(199,199,199,0.5) !important',
      },
      '&:hover': {
        background: 'rgba(199,199,199,0.1) !important',
      },
      '&:before': {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: 1,
        backgroundColor: 'rgba(199,199,199,0.5)',
        content: "' '",
      },
      '&:first-of-type:before': {
        display: 'none',
        paddingTop: 4,
      },
    },
  },

  // only apply these size limits to your Batch dropdown
  selectBatchRoot: {
    minWidth: '320px',
    maxWidth: '420px',
    width: 'fit-content',
  },
  selectBatchDropdown: {
    minWidth: '320px',
    maxWidth: '420px',
    width: 'fit-content',
  },
});

export default selectStatusStyle;
